import { createFileRoute } from '@tanstack/react-router'
import NotFound from './not-found'
import { HomePage } from '@/features/home/views'
import CoinAnimation from '@/ui/loader'
import {
  getUserControllerGetMeQueryKey,
  userControllerGetMe,
} from '@/api/users/users'
import { client } from '@/features/query/client'
import {
  getProfilesControllerGetMeQueryKey,
  profilesControllerGetMe,
} from '@/api/profiles/profiles'
import { UserDto } from '@/api/model'
import {
  getDreamControllerGetMyQueryKey,
  dreamControllerGetMy,
} from '@/api/dreams/dreams'
import {
  getFarmingControllerStatusQueryKey,
  farmingControllerStatus,
} from '@/api/farming/farming'
import {
  getWalletControllerGetWalletsQueryKey,
  walletControllerGetWallets,
} from '@/api/wallet/wallet'
import { getWalletSyncPromise } from '@/features/wallet-connect/wallet-signals'
import { syncWalletOnLoad } from '@/features/wallet-connect/sync-wallet-on-load'

export const Route = createFileRoute('/')({
  component: HomePage,
  notFoundComponent: NotFound,
  loader: async () => {
    // Синхронизируем состояние кошелька ДО загрузки данных
    await syncWalletOnLoad()

    return Promise.allSettled([
      client
        .fetchQuery({
          queryKey: getUserControllerGetMeQueryKey(),
          queryFn: () => userControllerGetMe(),
        })
        .then((data: UserDto) => {
          if (!data || !data.hasActiveDream) return

          return client.prefetchQuery({
            queryKey: getDreamControllerGetMyQueryKey(),
            queryFn: () => dreamControllerGetMy(),
          })
        }),
      client.prefetchQuery({
        queryKey: getProfilesControllerGetMeQueryKey(),
        queryFn: () => profilesControllerGetMe(),
      }),
      client.prefetchQuery({
        queryKey: getFarmingControllerStatusQueryKey(),
        queryFn: () => farmingControllerStatus(),
      }),
      // Предзагрузка данных кошелька для корректного отображения состояния
      client.prefetchQuery({
        queryKey: getWalletControllerGetWalletsQueryKey(),
        queryFn: () => walletControllerGetWallets(),
      }),
      // Ожидаем синхронизации кошелька (TON SDK + данные с бэкенда)
      getWalletSyncPromise(),
    ])
  },
  pendingComponent: CoinAnimation,
})
